export function countryName(countryCode: string, locale: string): string {
    const code = countryCode.trim().toUpperCase();
    try {
        return new Intl.DisplayNames([locale], {type: "region"}).of(code) ?? code;
    } catch {
        return code;
    }
}
